/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function SelectAction(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'SelectAction',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 19 * scale,
      viewBox: '0 0 15 19',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"#fff","stroke":"currentColor","strokeWidth":"2","d":"m3.65 15.104 1.318-1.126.624 1.424.392.894.904-.371 1.543-.634.947-.39-.411-.937-.6-1.367 1.71-.133 2.277-.175-1.674-1.554-6.966-6.468-1.672-1.552-.009 2.281L2 14.34l-.008 2.18z"}))
}
